import React from 'react';

interface WorkProcessItem {
  icon: string;
  title: string;
  description: string;
  lineShape?: string;
  iconBackground?: string;
  style?: 'default' | 'style-2';
}

interface KidsaWorkProcessProps {
  workProcessItems: WorkProcessItem[];
}

const KidsaWorkProcess: React.FC<KidsaWorkProcessProps> = ({
  workProcessItems
}) => {
  return (
    <section className="work-process-section fix section-padding fix" id="modelo">
      <div className="container">
        <div className="process-work-wrapper">
          <div className="row g-4">
            {workProcessItems.map((item, index) => {
              const isLastItem = index === workProcessItems.length - 1;
              
              return (
                <div 
                  key={index} 
                  className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" 
                  data-wow-delay={`.${(index + 3) * 0.1}s`}
                >
                  <div className={`work-process-items text-center ${item.style === 'style-2' ? 'style-2' : ''}`}>
                    {!isLastItem && item.lineShape && (
                      <div className={index === 1 ? 'line-shape-2' : 'line-shape'}>
                        <img src={item.lineShape} alt="shape-img" />
                      </div>
                    )}
                    
                    {!isLastItem ? (
                      <>
                        <div 
                          className="icon bg-cover" 
                          style={{ backgroundImage: `url('${item.iconBackground}')` }}
                        >
                          <i className={item.icon}></i>
                        </div>
                        <div className="container">
                          <h4>{item.title}</h4>
                          <p>{item.description}</p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="container style-two">
                          <h4>{item.title}</h4>
                          <p>{item.description}</p>
                        </div>
                        <div 
                          className="icon bg-cover" 
                          style={{ backgroundImage: `url('${item.iconBackground}')` }}
                        >
                          <i className={item.icon}></i>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaWorkProcess;